<template>
    <div>
        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" v-if="type === typeAfterSending">Sms sending results</h5>
                        <h5 class="modal-title" v-else>Sms will be sent for next bookings</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <div>
                            <table class="table table-bordered table-striped">
                                <caption class="d-none">Sms table</caption>
                                <tr>
                                    <th>Booking ID</th>
                                    <th>Customer name</th>
                                    <th>Phone</th>
                                    <th v-if="type === typeAfterSending">Status</th>
                                </tr>

                                <tr v-for="item in smsWillBeSendTo">
                                    <td>{{ item['bookingId'] }}</td>
                                    <td>{{ item['customerName'] }}</td>
                                    <td>{{ item['phone'] }}</td>
                                    <td v-if="type === typeAfterSending">
                                        <span v-if="sentSuccessfully[item['bookingId']]"
                                              class="text-success">{{ sentSuccessfully[item['bookingId']] }}</span>
                                        <span v-else class="text-danger">
                                            ERROR: {{ sentErrors[item['bookingId']] }}
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer" v-if="type === typeAfterSending">
                        <button class="btn btn-success" @click="toggleModal(); setPrepare();">Ok</button>
                    </div>
                    <div class="modal-footer d-flex" v-else>
                        <button class="btn btn-success" @click="smsSend">Send SMS</button>
                        <button class="btn btn-secondary" @click="toggleModal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>

        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>

        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>

</template>

<script>


import Loading from "vue-loading-overlay";
import smsMixin from "../../../mixins/smsMixin";

export default {
    name: "SmsResultModal",
    components: {Loading},
    mixins: [smsMixin],
    props: {},
    data() {
        return {
            show: false,
            activeModalInterval: false,
            type: 'prepare',
            typeAfterSending: 'After sending',
            typePrepare: 'prepare',
            smsWillBeSendTo: [],
            isLoading: false,
            smsTemplate: {},
            sentSuccessfully: [],
            sentErrors: {}

        }
    },
    methods: {
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        prepareDataForSms(smsTemplate) {
            this.isLoading = true;
            this.smsTemplate = smsTemplate;
            axios.post(`/sms/templates/${smsTemplate.id}/prepare-data`, smsTemplate)
                .then((response) => {
                    if (response.data.smsWillBeSendTo) {
                        this.smsWillBeSendTo = response.data.smsWillBeSendTo;
                        this.toggleModal();

                    } else {
                        this.flashMessage.error({
                            title: '',
                            message: 'No data',
                            time: 4000,
                            blockClass: 'flash-message error'
                        });
                        console.log('No data');
                    }
                }).catch((error) => {
                    console.error(error.response);
                    this.flashMessage.error({
                        title: '',
                        message: error.response.data.message || error.response.data || 'Error',
                        time: 4000,
                        blockClass: 'flash-message error'
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
        },
        async smsSend() {
            this.toggleModal();
            if (this.smsWillBeSendTo.length) {
                let result = await this.sendSms(this.smsTemplate.id, this.smsWillBeSendTo);
                if (result.sentSuccessfully) {
                    this.sentSuccessfully = result.sentSuccessfully;
                }

                if (result.errors) {
                    this.sentErrors = result.errors;
                }

                this.type = this.typeAfterSending;
                this.toggleModal();
            }
        },
        setPrepare() {
            this.type = this.typePrepare;
        }
    },

}
</script>

<style scoped>

</style>
